import { render, staticRenderFns } from "./address-book-picker.vue?vue&type=template&id=296ed2a0"
import script from "./address-book-picker.vue?vue&type=script&lang=js"
export * from "./address-book-picker.vue?vue&type=script&lang=js"
import style0 from "./address-book-picker.vue?vue&type=style&index=0&id=296ed2a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports